import { Outlet } from 'react-router'

const ProjectsMainLayout = () => {
  return (
    <Outlet />
  )
}

export default ProjectsMainLayout;